// tslint:disable:only-arrow-functions

type ThrottleFunc = () => any

export function throttle(func: ThrottleFunc, threshold: number = 250, scope?: any) {
  let last: number
  let deferTimer: any
  return function(t: any) {
    const context = scope || t
    const now = Date.now()
    const args = arguments
    if (last && now < last + threshold) {
      // hold on to it
      clearTimeout(deferTimer)
      deferTimer = setTimeout(function() {
        last = now
        func.apply(context, args)
      }, threshold)
    } else {
      last = now
      func.apply(context, args)
    }
  }
}
